module.exports = __webpack_public_path__ + "img/Currys--Gift-Card-Design@2x.4e48e03d.png";